export default "__VITE_ASSET__BkoDipqM__"